<div class="widget-container">
  <ion-grid>
    <ion-row class="close-row">
      <ion-col (click)="close()" class="close-col">
        <img src="../../../assets/icon/cancel.svg" alt="">
      </ion-col>
    </ion-row>
    <div>
      <ion-row class="header-row">
        <ion-col>
          <div *ngIf="this.seletedTab==='rm'" class="ion-text-start header-title">
            {{ 'Add Roadmaps' | translate }}
          </div>

          <div *ngIf="this.seletedTab==='qs'" class="ion-text-start header-title">
            {{ 'Select Question and Answers for Roadmaps' | translate }}
          </div>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col>
          <ion-card class="scrollVertical">
              <ion-row *ngIf="this.seletedTab==='rm'" class="machines-operations-container scroll-machine-list">
                <!-- Roadmap Card -->
                <ion-col size="12">
                    <ion-row class="clc-header">
                      <!-- <ion-col size="2" style="text-align: center;margin-left: -2px;">
                        <ion-checkbox [(ngModel)]="isAllRoadmapSelected" (ionChange)="changeAllSelectedRoadmap()">
                        </ion-checkbox>
                      </ion-col> -->
                      <ion-col size="12" style="text-align: left;">
                        <ion-label class="clch-title clch-extra-left-marg"> {{ 'Roadmap' | translate }}
                          ({{this.availableRoadMap.length}})</ion-label>
                      </ion-col>
                    </ion-row>
                    <ion-row class="machine-lists-container scrollBar">
                      <ion-col size="12">
                        <ion-item lines='none' style="--background: transparent;" *ngFor="let roadmap of this.availableRoadMap" class="item-view" >
                          <ion-row style="width: 100%;">
                            <ion-col size="1">
                              <ion-checkbox [(ngModel)]="roadmap.isRoadmapChecked" value="{{roadmap.roadMapMasterId}}" name="{{roadmap.roadMapName}}"
                            (ionChange)="changeRoadMapCheckboxSelection($event,roadmap)"></ion-checkbox>
                            </ion-col>
                            <ion-col size="11" style="padding-top: 22px;" >
                              <ion-label class="extra-label-marg line-break-label">
                                <h2 class="label" style="color: #000000;">{{roadmap.roadMapName}}</h2>
                              </ion-label>
                            </ion-col>
                          </ion-row>
                        </ion-item>
                      </ion-col>
                    </ion-row>
                </ion-col>
              </ion-row>
              <ion-row *ngIf="this.seletedTab==='qs'" class="machines-operations-container scroll-machine-list">
                <!-- Roadmap Card -->
                <ion-col size="12">
                    <ion-row class="clc-header">
                      <ion-col size="10" style="text-align: left;">
                        <ion-label class="clch-title clch-extra-left-marg"> {{ 'Selected Roadmaps' | translate }}
                          ({{this.selectedRoadmaps.length}})</ion-label>
                      </ion-col>
                    </ion-row>
                    <ion-row class="machine-lists-container scrollBar">
                      <ion-col size="12">
                        <ion-item lines='none' style="--background: transparent;" *ngFor="let roadmap of this.selectedRoadmaps" class="item-view" >
                          <ion-row style="width: 100%;">
                            <ion-col size="10" style="padding-top: 22px;">
                              <ion-label class="extra-label-marg line-break-label">
                                <h2 class="label" style="color: #000000;">{{roadmap.roadMapName}}</h2>
                              </ion-label>
                            </ion-col>
                            <ion-col size="2">
                            <ion-buttons>
                              <ion-button size="small" fill="clear" shape="round" [ngClass]="roadmap.isSelected ? 'green' : ''" (click)="changeAnswersCheckboxSelection(true, roadmap)">{{ 'yes' | translate }}</ion-button>
                              <ion-button size="small" fill="clear" shape="round"  (click)="changeAnswersCheckboxSelection(false, roadmap)">{{ 'no' | translate }}</ion-button>
                            </ion-buttons>
                            </ion-col>
                          </ion-row>
                        </ion-item>
                      </ion-col>
                    </ion-row>
                </ion-col>
              </ion-row>
          </ion-card>
        </ion-col>
      </ion-row>
      <ion-grid>
        <ion-row no-padding no-margin>
          <ion-col size="8" no-padding>
          </ion-col>
          <ion-col size="2" no-padding *ngIf="this.seletedTab==='rm'">
            <ion-button  class=cancel-btn shape="round" size="medium" fill="outline" (click)="close()">
              {{ 'Cancel' | translate }}
            </ion-button>
          </ion-col>
          <ion-col size="2" no-padding *ngIf="this.seletedTab==='qs'">
            <ion-button  shape="round" class="add-offer-btn1" size="medium" (click)="previous()">
              {{ 'Back' | translate }}
            </ion-button>
          </ion-col>
          <ion-col size="2" no-padding *ngIf="this.seletedTab==='rm'" >
            <ion-button shape="round" class="add-offer-btn1" size="medium" (click)="next()">
              {{ 'Next' | translate }}
            </ion-button>
          </ion-col>
          <ion-col size="2" no-padding *ngIf="this.seletedTab==='qs'">
            <ion-button shape="round"  class="add-offer-btn1" size="medium" (click)="submit()">
              {{ 'Save' | translate }}
            </ion-button>
          </ion-col>
        </ion-row>
      </ion-grid>
    </div>
  </ion-grid>
</div>





